// require('lib/newsTabs')();
require('lib/descriptHeight')();
require('es6-promise').polyfill();
// require('whatwg-fetch');
require('lib/home')();
require('lib/gallery')();
require('lib/popups')();
require('lib/history')();
require('lib/contacts/index')(document.querySelector('.contacts'));
require('lib/params-list')();
require('lib/cart')();
require('lib/news/index')();
require('lib/menu')();
require('lib/vacancy')();

require('react-app');



/** WEBPACK FOOTER **
 ** ./src/scripts/main.js
 **/